<template>
  <div class="privacy-container">
    <van-nav-bar
      title="隐私政策"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="content">
      <h1 class="title">隐私政策</h1>
      
      <p class="version-info">版本更新日期：2025年 9 月 29 日</p>
      <p class="version-info">版本生效日期：2025年 9 月 29 日</p>

      <p>由北京聚灵活科技有限公司及其关联方（以下或称"我们"）作为管理平台的运营方，我们深知个人信息对你的重要性，我们将按照法律法规的规定，保护您的个人信息及隐私安全。我们制定本隐私政策并希望提示你了解下述内容，以便作出适当选择。</p>
      
      <h2 class="section-title">一、法律声明</h2>
      <p>欢迎您使用管理平台，管理平台是一个提供多样化功能的企业管理与服务平台，包括各版本客户端应用程序以及链接云平台的公众号（以下或称"平台"）服务！本隐私权政策适用于平台向您提供的所有服务。在使用平台服务前，请您务必仔细阅读并理解以下条款。对本政策中我平台认为可能与您的权益存在重大关系的条款和个人敏感信息，平台采用<strong>粗体字</strong>进行标注。</p>
      <p>如您就本政策点击或勾选"同意"并确认提交，即视为您同意本政策，并同意平台将按照本政策来收集、使用、存储和共享您的相关信息。</p>
      <p>1、为了便于您了解您在使用我们服务时，我们需要收集的信息类型与用途，我们将结合具体的服务向您逐一说明。</p>
      <p>2、为了向您提供服务所需，我们会按照合法、正当、必要的原则收集您的信息。我们将会在您使用特定业务功能时，仅收集为了正常运行该业务功能所必需的信息，在您停止该业务功能的使用后，我们将会停止您的个人信息收集行为。</p>
      <p>3、为了向您提供服务所需，您同意我们有权协助您完成注册、认证等相关事宜，我们仅提供协助服务，注册或认证完成后的相关事宜由您本人负责。</p>
      <p>4、如果为了向您提供服务而需要将您的信息共享至第三方，我们将评估该第三方收集信息的合法性、正当性、必要性。我们将要求第三方对您的信息采取保护措施并且严格遵守相关法律法规与监管要求。另外，我们会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗提示等形式征得您的同意或确认第三方已经征得您的同意。</p>
      <p>5、您可以通过本政策介绍的方式访问和管理您的信息、设置隐私功能。</p>
      
      <h2 class="section-title">二、适用范围</h2>
      <p>您具体获得的管理平台服务内容可能因为您使用的管理平台的版本不同而有所差异。</p>
      <p>此隐私权政策旨在帮助您了解我们会收集哪些数据、为什么收集这些数据，会利用这些数据做些什么以及如何保护这些数据。</p>
      <p>请您务必认真阅读本隐私政策，在确认充分了解并同意后使用管理平台服务。</p>
      <p>需要特别说明的是，本隐私政策不适用于管理平台关联方、管理平台合作机构或其他第三方向您提供的服务。管理平台也可能含有到其他网站的链接，我们会依据法律法规的要求采取必要措施对相关网站进行审查(包括审查网站经营者的基本资质、通过技术手段对相关网站的安全情况进行合理且初步识别、督促该网站经营者根据法律规定保护您的个人信息安全)，但我们无法保证该链接网站的运营方会按照我们的要求采取保护措施。我们建议您查看该等网站的隐私权政策，了解他们如何处理您的信息，以便审慎决策。</p>
      <p>请您注意：通过管理平台为您提供产品和服务的第三方、您通过管理平台所访问的网站运营方以及通过管理平台API接收您的信息并为您提供服务的第三方，均会根据其自身隐私政策所述标准存储、使用、处理和保护您的个人信息，本隐私政策不能代替上述第三方的隐私政策。我们会尽力要求第三方服务提供商为您的个人信息提供足够的安全保护水平并会在具体产品页面明确告知您服务由特定第三方提供，同时强烈建议您在使用上述第三方服务前先行了解、确认服务提供方的隐私保护情况。</p>
      <p>我们深知个人信息对您的重要性，也深知为您的信息提供有效保护是我们业务健康可持续发展的基石。感谢您对管理平台的使用和信任！我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。我们郑重承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</p>
      
      <h2 class="section-title">三、我们如何收集和使用您的个人信息</h2>
      <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。个人信息包括姓名、出生日期、身份证件信息（身份证、护照等）、个人生物识别信息、通信通讯联系方式、住址、账户信息、财产状况、位置信息等。</p>
      <p>个人敏感信息是指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括：生物识别信息、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的信息。</p>
      <p>1、为了向您提供更好、更个性化的产品和服务，下列描述列表是我们会为您提供的功能、服务以及各项业务功能和服务会收集的个人信息：</p>
      <p>1）设备信息，包括设备型号、操作系统版本、唯一设备标识符、信号强度等信息。</p>
      <p>2）软件信息，包括软件的版本号、浏览器类型。</p>
      <p>3）IP地址信息</p>
      <p>4）服务日志信息，包括您在使用我们服务时搜索、查看的信息、服务故障信息、引荐网址等信息。当您登陆平台的时候，需输入相关信息用于管理平台；</p>
      <p>5）设备信息，当您需要进行人脸识别时，至少需要提供设备的摄像头、麦克风、设备音量、设备电量、设备剩余内存的权限；</p>
      <p>6）地理位置信息，当您使用管理平台时，我们会收集您的地理位置信息(其中精准定位信息为个人敏感信息)。</p>
      <p>7）当您使用管理平台分享内容到第三方app时，我们会获取您的设备的应用列表，用来判断第三方是否支持分享；</p>
      <p>2、我们会从关联公司、业务合作伙伴来源获得您的相关信息。例如当您通过我们关联公司、业务合作伙伴网站及其移动应用软件等预订时，您向其提供的预订信息会转交给我们，以便我们为您提供服务。</p>
      <p>请您理解，我们向您提供的服务是不断更新和发展的。如您选择使用了前述说明当中尚未涵盖的其他服务，基于该服务我们需要收集您的信息的，我们会通过页面提示、交互流程、协议约定的方式另行向您说明信息收集的范围与目的，并征得您的同意。我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息；如您选择不提供前述信息，您可能无法使用某项或某部分服务，但不影响您使用我们提供的其他服务。此外，第三方主体可能会通过管理平台向您提供服务。当您进入第三方主体运营的服务页面时，请注意相关服务由第三方主体向您提供。涉及到第三方主体向您收集个人信息的，建议您仔细查看第三方主体的隐私政策或协议约定。</p>
      <p>3、事先征得授权同意的例外，在以下情形中，收集、使用个人信息无需事先征得您的授权同意：</p>
      <p>1）与国家安全、国防安全有关的；</p>
      <p>2）与公共安全、公共卫生、重大公共利益有关的；</p>
      <p>3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
      <p>4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p>5）所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
      <p>6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
      <p>7）根据您的要求签订合同所必需的；</p>
      <p>8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</p>
      <p>9）为合法的新闻报道所必需的；</p>
      <p>10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
      <p>11）法律法规规定的其他情形。</p>
      <p>4、我们申请的设备权限：</p>
      <p>管理平台在提供服务过程中，会调用您的一些设备权限。以下是管理平台调用权限对应的业务功能、调用权限的目的以及调用权限前向您询问的情况。</p>
      <p>您可以在设备的设置功能中选择关闭部分或全部权限，从而拒绝管理平台收集相应的个人信息。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。</p>
      <p>此外，您在使用管理平台对应的服务时候可能需要调用或者使用您的设备功能用于收集和使用您的个人信息。当您使用服务之前，您可选择是否授权开通以下权限:</p>
      <p>1）基于摄像头(相机、存储)的功能:您可开启摄像头进行身份校验(人脸识别)、拍照并上传图片操作以及使用视频服务;</p>
      <p>2）基于相册的功能:当您进行订单数据获取时，您可从本地相册中选择图片上传。通过开启允许访问相册功能;</p>
      <p>3）基于地理位置的功能:您可开启定位服务，以便在需要双录视频录制过程中获取您的地理位置;</p>
      <p>4）基于麦克风的功能:您可选择麦克风设备以进行视频录制过程中进行语音回答;</p>
      <p>5）获取设备信息的功能:为了更好的提供服务满足投保流程的监管要求，我们需要获取设备信息(包括IMEI、MAC地址、IMSI、手机设备唯一标识)、检测网络状态、平台运行状态及系统运行状态，以保证账户登录和服务的安全性；</p>
      <p>6）读取设备已安装应用信息的功能:在您使用分享功能时，我们会检测您的设备上是否安装对应的应用；</p>
      <p>7）READ_LOGS权限(读取系统日志文件):您在使用平台安卓版时，我们会使用到该权限收集平台运行日志，用于后续排查平台运行状态和优化我们的服务；</p>
      <p>8）剪切板权限：您在使用平台时，我们在输入场景下，监测您的剪切板，以便协助您快速复制粘贴输入。</p>
      <p>上述功能需要您在您的设备中向我们开启您的存储、电话、摄像头(相机)、相册、地理位置(定位)、麦克风功能的访问权限，以实现这些功能所涉及的信息的收集和使用。您确认并同意开启这些权限即代表您授权我们可以收集和使用这些信息来实现上述功能:您也可以遵循您使用设备的操作系统指示变更或者取消这些授权，则我们将不再继续收集和使用您的这些信息，也无法为您提供上述与这些授权所对应的功能，但这不会对您使用管理平台其他服务产生影响。</p>
      <p>请您理解，我们向您提供的服务是不断更新和发展的。如您选择使用了前述说明当中尚未涵盖的其他服务，基于该服务我们需要收集您的信息的，我们会通过页面提示、交互流程或协议约定的方式另行向您说明信息收集的范围与目的，并征得您的同意。</p>
      
      <h2 class="section-title">四、我们接入的第三方及我们如何共享、转让、公开披露您的个人信息</h2>
      <p>（一）我们接入的第三方</p>
      <p>为了使您能够接收信息推送、在第三方平台分享信息及完成相关操作，基于为您提供服务的需求，我们的应用中接入了第三方合作方，具体第三方信息如下表所述：</p>
      <p>（二）您在使用我们的服务时主动提供的信息</p>
      <p>1、账户注册</p>
      <p>在您注册平台账户或使用平台服务时，您需提供昵称、头像、手机号码或者电子邮箱作为账户登录名。如您不提供前述信息，可能无法注册账户或无法使用服务。</p>
      <p>2、实名认证</p>
      <p>我们需根据相关法律法规及监管要求，您需要提供姓名、证件类型、证件号码、证件有效期限。提示您适时提供有效身份证件的彩色影印件或照片以供我们核对并留存；如您不提供前述彩色影印件、照片或不同意我们留存，可能无法使用与监管要求相关的部分服务，但不影响您使用我们提供的其他服务。</p>
      <p>3、重要操作行为验证</p>
      <p>为了保障您的账户和资金安全，在您进行一些重要的账户操作时（例如：找回密码、挂失账户、冻结交易资金等），我们需要验证您的身份，为此您可能需向我们提供身份证件影印件、手持身份证照片、交易凭证及其他在具体业务开展过程中基于您的同意而收集的可识别您身份的证明资料；如您不同意提供前述信息，您将无法完成特定操作，但不影响您使用我们提供的其他服务。</p>
      <p>（三）我们如何共享您的个人信息</p>
      <p>1、我们会以高度的勤勉义务对待您的信息。在获得您的明确同意后，我们会与其他方共享您的个人信息。我们可能会根据法律法规规定，或按照法律法规、法律程序的要求或强制性的政府要求或司法裁定，对外共享您的个人信息。</p>
      <p>2、仅为实现本隐私政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。</p>
      <p>（四）我们如何转让您的个人信息</p>
      <p>我们不会将您的个人信息转让给其他公司、组织和个人，但以下情况除外：</p>
      <p>（1）事先获得您的明确授权或同意；</p>
      <p>（2）满足法律法规、法律程序的要求或强制性的政府要求或司法裁定；</p>
      <p>（3）如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该等信息在转移时的机密性，并尽最大可能确保新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
      <p>（五）个人信息的公开披露</p>
      <p>1.我们仅会在以下情况下，公开披露您的个人信息：</p>
      <p>（1）获得您的明确同意；</p>
      <p>（2）基于法律法规、法律程序、诉讼或政府主管部门强制性要求下。</p>
      <p>（六）共享、转让、公开披露个人信息时事先征得授权同意的例外,在以下情形中，共享、转让、公开披露个人信息无需事先征得个人信息主体的授权同意：</p>
      <p>（1）与国家安全、国防安全直接相关的；</p>
      <p>（2）与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
      <p>（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p>（5）个人信息主体自行向社会公众公开的个人信息；</p>
      <p>（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
      
      <h2 class="section-title">五、我们如何保存及保护您的个人信息</h2>
      <p>（一）个人信息保存期限</p>
      <p>为了您能够使用管理平台的多样化产品服务以及有效处理可能产生的争议，除满足法律法规对于数据留存的强制性要求外，我们将在您使用管理平台期间（使用期间是指您注销账户之前）及相关行为的诉讼时效届满前保存您的个人信息。在超过上述期限后，我们会对您的信息进行删除或进行匿名化处理（即会对您的个人信息进行处理以使您的身份无法被任何第三方识别）。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.privacy-container {
  padding-bottom: 30px;
  background-color: #fff;
  min-height: 100vh;
}

.content {
  padding: 15px;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  color: #355DFF;
}

.version-info {
  text-align: center;
  margin-bottom: 10px;
  color: #666;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 10px;
  color: #355DFF;
}

p {
  margin-bottom: 10px;
  text-align: justify;
}

strong {
  font-weight: bold;
  color: #355DFF;
}
</style>
